import { throttle } from 'lodash';
import { useLayoutEffect, useState } from 'react';

const useScrollPosition = (throttleMs = 100) => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useLayoutEffect(() => {
    const handleWindowScroll = throttle(() => {
      setScrollPosition(document.documentElement.scrollTop);
    }, throttleMs);

    window.addEventListener('scroll', handleWindowScroll);

    return () => window.removeEventListener('scroll', handleWindowScroll);
  }, []);

  return scrollPosition;
};

export default useScrollPosition;
